<table [dataSource]="schedulesData" mat-table>
  <ng-container matColumnDef="quantity">
    <th *matHeaderCellDef mat-header-cell>Quantity</th>
    <td *matCellDef="let row" mat-cell> {{ row.quantity }}</td>
  </ng-container>
  <ng-container matColumnDef="sorCode">
    <th *matHeaderCellDef mat-header-cell>SOR Code</th>
    <td *matCellDef="let row" mat-cell>
      {{ row.sorDescription }} - {{ row.sorCode }}
    </td>
  </ng-container>
  <ng-container matColumnDef="externalScheduleReference">
    <th *matHeaderCellDef mat-header-cell>External Schedule Reference</th>
    <td *matCellDef="let row" mat-cell> {{ row.externalScheduleReference }}</td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row>
</table>

